import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@/components/layout'

import styles from './BlogArticleListingSmallHeader.module.scss'

const BlogArticleListingSmallHeader = ({ title }) => (
  <Box className={styles.wrapper} gap={0}>
    <h4>{title}</h4>
  </Box>
)

BlogArticleListingSmallHeader.propTypes = {
  title: PropTypes.string,
}

export default BlogArticleListingSmallHeader
